import { render } from "./CreateNewInvoiceModal.vue?vue&type=template&id=54848fbf&ts=true"
import script from "./CreateNewInvoiceModal.vue?vue&type=script&lang=ts"
export * from "./CreateNewInvoiceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__